import { Constants } from 'constants/Constants';
import oAxiosInstance from 'redux/interceptors/Interceptors';

const URL_USERS = `${Constants.API_URL}users/`;

/**
 * Servicio que toma los usuarios registrados en el sistema
 * 
 * @author Leandro Curbelo
 */
export const Get = (nPage, sFilter) => {
    return oAxiosInstance.post(`${URL_USERS}`, { page: nPage, search: sFilter }).then(oResult => oResult.data);
}
/**
 * Servicios que obtiene un determinado usuario
 * 
 * @param {number} nId Identificador primario del usuario
 * 
 * @author Leandro Curbelo
 */
export const Find = (nId) => {
    return oAxiosInstance.get(`${URL_USERS}${nId}`).then(oResult => oResult.data);
}
/**
 * Servicio que almacena un nuevo usuario en el sistema
 * 
 * @param {object} oData Datos necesarios para dar de alta un nuevo usuario en el sistema.
 * 
 * @author Leandro Curbelo
 */
export const Add = (oData) => {
    return oAxiosInstance.post(`${URL_USERS}add`, { data: oData }).then(oResult => oResult.data);
}
/**
 * Servicios que actualiza los datos de un usuario
 * 
 * @author Leandro Curbelo
 */
export const Update = (nId, oData) => {
    return oAxiosInstance.post(`${URL_USERS}${nId}`, { data: oData }).then(oResult => oResult.data);
}
/**
 * Servicios que actualiza las credenciales del usuario
 * 
 * @author Leandro Curbelo
 */
export const ChangePassword = (nId, oData) => {
    return oAxiosInstance.post(`${URL_USERS}${nId}/change/password`, { data: oData }).then(oResult => oResult.data);
}
/**
 * Servicio elimina un usuario del sistema
 * 
 * @author Leandro Curbelo
 */
export const Delete = (nId) => {
    return oAxiosInstance.get(`${URL_USERS}${nId}/remove`).then(oResult => oResult.data);
}